/* eslint-disable no-unused-vars */
// noinspection ES6UnusedImports
import 'core-js/modules/es.array.at';
import 'idempotent-babel-polyfill';

import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { withRouter } from 'react-router';

import reducers from './reducers';

import AdmissionsReportNav from "./components/reporting/AdmissionsReportNav";
import SchedulingSnippetEditor from './components/communication/SchedulingSnippetEditor';
import EmailWorkflow from './components/communication/EmailWorkflow';
import MMSWorkflow from './components/communication/MMSWorkflow';
import WebSnippetList from './components/communication/WebSnippetList';
import UserEmailWorkflow from './components/communication/UserEmailWorkflow';
import BulkPrint from './components/ContactList/BulkActionModals/BulkPrint';
import BulkDownload from './components/ContactList/BulkActionModals/BulkDownload';
import BulkManageReaders from './components/ContactList/BulkActionModals/BulkManageReaders';
import BulkManageCounselors from './components/ContactList/BulkActionModals/BulkManageCounselors';
import BulkCSVExport from './components/ContactList/BulkActionModals/BulkCSVExport';
import CounterSignatureModal from './components/admin_portal/CounterSignatureModal';
import FlashRoot from './components/FlashMessage/FlashRoot';
import PaymentPlanEditor from './components/setup/PaymentPlan/PaymentPlanEditor';
import PaymentPlanScheduleEditor from './components/setup/PaymentPlan/PaymentPlanScheduleEditor';
import PaymentPlanList from './components/setup/PaymentPlan/PaymentPlanList';
import RateCard from './components/setup/RateCard';
import ContractGeneration from './components/admin_portal/BulkContractCreation/ContractGeneration';
import ContractGenerationVerification from './components/admin_portal/BulkContractCreation/ContractGenerationVerification';
import TuitionField from './components/fields/TuitionField';
import PaymentPlanField from './components/fields/PaymentPlanField';
import TotalsSummaryField from './components/fields/TotalsSummaryField';
import CandidatesInReviewContactList from './components/Review/CandidatesInReviewContactList';
import InstallmentEditor from './components/setup/PaymentPlan/InstallmentEditor';

import Routes from './routes';
import GenderField from './components/fields/GenderField';
import UploadedItem from './components/fields/UploadedItem';
import UploadFieldList from './components/fields/UploadFieldList';
import MatchWizard from './components/form_matching/MatchWizard';
import MultipleAppointments from './components/form_matching/MultipleAppointments';
import CustomerNote from './components/setup/CustomerNote';
import ManagedResourceList from './components/shared/ManagedResourceList';
import TuitionAndFeesTotalsHeader from './components/ContactList/TuitionAndFeesTotalsHeader';
import SchoolYearConfigPage from './components/setup/SchoolYearConfigPage';
import LotteryConfigurationsIndex from './components/setup/lotteries/LotteryConfigurationsIndex';
import SchoolYearsWrapper from './components/setup/SchoolYearsWrapper';
import DefaultForReportingDropdown from './components/setup/DefaultForReportingDropDown';

import SplitDepositPayment from './components/contracts/SplitDepositPayment';

// These imports are required to enable the registeredComponents feature.
// Would be nice to find a way to take these out, but webpack can only build files it knows about.
import AddressField from './components/fields/AddressField';
import BillingAccountAccessPickerList from 'components/billing/BillingAccountAccessPickerList';
import BlackbaudConfigShow from './components/setup/BlackbaudConfigShow';
import ChecklistSnippetEditor from './components/communication/ChecklistSnippetEditor'
import FormTemplateInfo from './components/form_editing/FormTemplateInfo';
import DataRetention from './components/setup/DataRetention';
import Downloader from './components/Downloader';
import FactsUserAccounts from './components/ContactRecord/FactsUserAccounts';
import FactsWebProvidedXML from './components/ContactRecord/FactsWebProvidedXML';
import FieldEditor from './components/form_editing/FieldEditor';
import ModalRoot from './components/ModalRoot';
import Activities from './components/activities/Activities';
import OrderForm from './components/payments/OrderForm';
import FormPayment from './components/payments/FormPayment';
import PageEditor from './components/form_editing/PageEditor';
import RefundComponentButton from './components/refunds/RefundComponentButton';
import SsatbComponentEditor from './components/setup/SsatbComponentEditor';
import StripeCustomOnboarding from './components/payments/stripe/StripeCustomOnboarding';
import TagInput from "./components/Tagging/TagInput";
import RequireAutopay from './components/contracts/RequireAutopay';
import TestScoreViewer from './components/fields/TestScoreViewer';

import FusionForm from './components/fusion_forms/FusionForm';

import * as ducks from './ducks/index';

import { createStore, combineReducers, compose, applyMiddleware } from 'redux';

import thunkMiddleware from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import history from './shared_history';

import Cookies from 'js-cookie';

import { getComponent } from './utils/registeredComponent';

// Gotta include the registered components somewhere:
import FinancialSplit from './components/billing/FinancialSplit';
import FontAwesomeHelper from './components/shared/FontAwesomeHelper'

import './components/styles/ReactSelect.scss';

// Ideally, this would set these defaults on all modals. Unfortunately, when using Modal from react-bootstrap, that
// component uses it's own defaults that are in turn always passed to Bootstrap Modal. As such, we still have to
// specify `backdrop='static' keyboard={false}` on every react-bootstrap Modal.
// While this import won't have any effect on react-bootstrap Modal, it would still have effect if using
// Bootstrap Modal directly.
import 'Legacy/helpers/shared/bootstrap_modal_defaults';
import SharedPortalRoutes from "./SharedPortalRoutes";

let reactInstance = null;
class ReactComponentWrapper {
  constructor() {
    if (!reactInstance) {
      reactInstance = this;
    }
    this.store = null;

    this.ducks = ducks;
    this.isInitialized = false;

    return reactInstance;
  }

  dispatch(action) {
    if (!this.store) {
      throw new Error("Redux store has not been initialized");
    }

    this.store.dispatch(action);
  }

  createStore(initialState) {
    this.store = createStore(
      combineReducers({
        ...reducers,
        routing: routerReducer
      }),
      initialState,
      compose(
        applyMiddleware(thunkMiddleware, routerMiddleware(history)),
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
      )
    )
  }

  renderComponent(dest, component) {
    if (!this.store) {
      throw new Error("Redux store has not been initialized");
    }

    ReactDOM.render(
      <Provider store={this.store}>
        {component}
      </Provider>,
      dest
    );
  }

  unmountComponent(dest) {
    return ReactDOM.unmountComponentAtNode(dest);
  }

  renderRoutes(dest) {
    this.renderComponent(dest, <Routes store={this.store} />);
  }

  renderSharedPortalRoutes(dest, branded_shared_portal_host) {
    this.renderComponent(dest, <SharedPortalRoutes store={this.store} branded_shared_portal_host={branded_shared_portal_host} />);
  }

  renderSchedulingSnippetEditor(dest, opts) {
    this.renderComponent(dest, <SchedulingSnippetEditor {...opts} key={`scheduling_snippet_editor${Math.random() % 100}`} />);
  }

  renderMatchWizard(dest, opts) {
    this.renderComponent(dest, <MatchWizard {...opts} />, dest)
  };

  renderCustomerNote(dest, opts) {
    this.renderComponent(dest, <CustomerNote {...opts} />);
  };

  renderSchoolYearConfigPage (dest, opts) {
    this.renderComponent(dest, <SchoolYearConfigPage {...opts} />)
  }

  renderSchoolYearsWrapper(dest, opts) {
    this.renderComponent(dest, <SchoolYearsWrapper {...opts} />)
  }

  renderDefaultForReportingDropdown(dest, opts) {
    this.renderComponent(dest, <DefaultForReportingDropdown {...opts} />)
  }

  renderLotteries(dest, opts) {
    this.renderComponent(dest, <LotteryConfigurationsIndex {...opts} />)
  }

  renderTestScoreViewer(dest, opts) {
    this.renderComponent(dest, <TestScoreViewer {...opts} />);
  };

  renderSnippetList(dest, opts) {
    switch (opts.type) {
      case 'webSnippet':
        this.renderComponent(dest, <WebSnippetList {...opts} />);
        break;
    }
  }

  renderCommunicationSelectControl(dest, opts) {
    this.renderComponent(dest, <ChecklistSnippetEditor {...opts} />)
  }

  renderContactActivities(dest, opts) {
    this.renderComponent(dest, <Activities {...opts} />)
  }

  renderCommunicationWorkflow(dest, opts) {
    switch (opts.type) {
      case 'email':
        this.renderComponent(dest, <EmailWorkflow {...opts} />);
        break;
      case 'userMailer':
        this.renderComponent(dest, <UserEmailWorkflow {...opts} />);
        break;
      case 'mms':
        this.renderComponent(dest, <MMSWorkflow {...opts} />);
        break;
    }
  }

  renderBulkPrintWorkflow(dest, opts) {
    this.renderComponent(dest, <BulkPrint {...opts} onClose={() => this.unmountComponent(dest)} />);
  }

  renderBulkDownloadWorkflow(dest, opts) {
    this.renderComponent(dest, <BulkDownload {...opts} onClose={() => this.unmountComponent(dest)} />);
  }

  renderBulkManageReadersModal(dest, opts) {
    this.renderComponent(dest, <BulkManageReaders {...opts} handleClose={() => this.unmountComponent(dest)} />);
  }

  renderBulkManageCounselorsModal(dest, opts) {
    this.renderComponent(dest, <BulkManageCounselors {...opts} handleClose={() => this.unmountComponent(dest)} />);
  }

  renderBulkCSVExportWorkflow(dest, opts) {
    this.renderComponent(dest, <BulkCSVExport {...opts} onClose={() => this.unmountComponent(dest)} />);
  }

  renderRegisteredComponent(name, dest, opts = {}) {
    const component = getComponent(name);

    this.renderComponent(dest, React.createElement(component, opts));
  }

  localStorageEnabled() {
    // Check if localStorage is available.  If not, use cookies...
    try {
      // Test webstorage existence.
      if (!window.localStorage || !window.sessionStorage) throw "exception";
      // Test webstorage accessibility - Needed for Safari private browsing.
      localStorage.setItem('storage_test', 1);
      localStorage.removeItem('storage_test');

      return true;
    } catch (e) {
      return false;
    }
  }

  initialize(opts) {
    const { state: { httpConfig: {
      baseUrl,
      sa0BaseUrl
    } } } = opts;

    this.baseUrl = baseUrl;
    this.sa0BaseUrl = sa0BaseUrl;

    this.authHeaders = opts.authHeaders;

    if (this.localStorageEnabled()) {
      window.localStorage.setItem('authHeaders', JSON.stringify(this.authHeaders));
    }
    else {
      Cookies.set('authHeaders', JSON.stringify(this.authHeaders));
    }

    const { state = {} } = opts;

    this.createStore({
      ...state
    });

    this.isInitialized = true;
  }
}

global.ReactComponent = new ReactComponentWrapper();
